import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'semantic-ui-react'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import { MilkMoneyQuery } from '~/QueryHooks/MilkMoneyQuery'
import { Nullable } from '~/types'

type DataFilterType = {
  rows: number,
  page: number,
  month: string
}

const MilkDelivery:React.FC = () => {
  const { t } = useTranslation()
  const tableColumnHeaders = [
    {
      name: t('Starting date'),
      key: 'dateStart',
      type: 'date',
      format: 'DD.MM.YYYY'
    },
    {
      name: t('Tour data id'),
      key: 'uniqueId'
    },
    {
      name: t('Tour no.'),
      key: 'tourNumber'
    },
    {
      name: t('Amount accepted (in l)'),
      key: 'amount',
      type: 'no-unit-number',
      decimalScale: 0
    },
    {
      name: t('avg. Temp. (°C)'),
      key: 'avgTemp',
      type: 'no-unit-number',
      decimalScale: 1
    },
    {
      name: t('Sample bottle'),
      key: 'sampleBottleNumber'
    },
    {
      name: t('Sample Compartment Temp (°C)'),
      key: 'sampleAvgTemp',
      type: 'no-unit-number',
      decimalScale: 1
    }
  ]
  const [dataFiltered, setDataFiltered] = useState<Nullable<DataFilterType>>(null)

  const {
    data: options,
    isLoading: isLoadingOptions
  } = MilkMoneyQuery.getFarmDeliveriesData()

  const {
    data: milkDeliveries,
    isLoading: isLoadingDeliveries,
    isFetching: isFetchingDeliveries,
    refetch: fetchData
  } = MilkMoneyQuery.getFarmDeliveries(dataFiltered && {
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  })

  useEffect(() => {
    if(!dataFiltered && options) {
      setDataFiltered({
        rows: 20,
        page: 0,
        month: options.months[0].key
      })
    }
  }, [options, dataFiltered])

  useEffect(() => {
    if(dataFiltered) {
      fetchData()
    }
  }, [dataFiltered])

  function renderTable() {
    return <TableComponent
      rows={rows}
      total={filtered}
      tableColumnHeaders={tableColumnHeaders}
      isFetchingData={isFetchingDeliveries}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      animated
    />
  }

  function renderFilters() {
    return <>
      <Dropdown
        selectOnBlur={false}
        placeholder={t('Select date')}
        selection
        options={options?.months?.map(month => ({ text: month.label, value: month.key })) || []}
        value={dataFiltered?.month}
        onChange={(_, { value }) => {
          setDataFiltered({
            ...dataFiltered,
            month: value as string
          })
        }}
      />
    </>
  }

  const { filtered, rows } = milkDeliveries ? milkDeliveries : { filtered: 0, rows: [] };
  const isLoading = isLoadingDeliveries || isLoadingOptions

  return <Layout
    title={t('Milk delivery')}
    segmented
    isBusy={isLoading}
    filters={renderFilters()}
  >
    {dataFiltered && milkDeliveries && renderTable()}
  </Layout>
}
export default MilkDelivery